const HelpUsData={
    "Registration":[
        {
            header:'How do i register ?',
            content:'You can register by clicking on the "Sign In" section located at the top right corner on the home page. Please provide the required information in the form that appears and click on submit. We will send a one-time password (OTP) to verify your mobile number. Post verification, you can start shopping on JioMart.',
        },
        {
            header:'Do I need to register before shopping on JioMart?',
            content:'Yes, you do need to register before shopping with us. However, you can browse the website without registration. You are required to login or register while you checkout.',
        },
        {
            header:'Can I register multiple times using the same phone number/email ID?',
            content:'Each email ID/login ID and mobile number can only be associated with one customer account.'
        }
    ],
    "Login":[
        {
            header:'What is My Account?',
            content:' "My Accountis" the section where you can view your Personal Information, Order History and Shopping List.'
        },
        {
            header:'I am unable to login',
            content:'You may have entered incorrect login details. Please enter the correct information & try again.'
        }
    ],
    "ProductPrice":[
        {
            header:'How do I look for a particular Product?',
            content:'You can search for a product by navigating through the category pages or by using search tab on the top of every page'
        },
        {
            header:'How will you ensure the freshness of products?',
            content:'We ensure that all our products are hygienically and carefully handled and maintain them in the correct temperature & packaging.'
        },
        {
            header:'How can I check if the product I am ordering is in stock?',
            content:'You can prepare your cart and select the address you want the order to be delivered at. The availability of the product will be dependent on the selected address. Product without availability will be shown as ‘Out of stock’. You may remove them or add similar products as per your convenience.'
        }
    ],
    "Ordering":[
        {
            header:'How do I know if I placed my order correctly?',
            content:'Upon the successful completion of your order, an order confirmation e-mail and SMS containing your order details will be sent to your registered email ID and phone number.'
        },
        {
            header:'Can I call and place an order?',
            content:'No, currently this service is not available.'
        },
        {
            header:'How are the fruits and vegetables weighed?',
            content:'All fruits and vegetables vary in size and weight. You can choose any size/weight available on the website. While you shop, we will show an estimated weight and price. At the time of processing, we pack the closest size/weight and charge you for the actual weight of each item. E.g. If you order 1 kg of apples, we will try to pack exactly 1 kg or the weight closest to 1 kg. If the actual weight is 987 gm, we will bill you for 987 gm and not 1 kg.'
        },
        {
            header:'How do I make changes to my order?',
            content:'Currently, there is no provision to modify the order once it is placed. You may cancel the order until it is shipped. You may request for a return of the ordered product as per the return policy.'
        }
    ],
    "Payment":[
        {
            header:'What are the various modes of payment I can use for shopping?',
            content:'You can pay for your order using the following modes of payment:'
        },
        {
            header:'Can I pay online during the delivery of the product?',
            content:'You can pay by scanning the QR available on the invoice using any UPI app at the time of delivery. Please check with the delivery executive to assist you.'
        },
        {
            header:'I have placed an order with Cash on Delivery option. Can I change the payment method now?',
            content:'Payment method cannot be changed once the order is placed.'
        },
        {
            header:'How much time will it take to get the refund of a cancelled/returned order?',
            content:'Refund against a cancelled or return product may take up to 7 working days depending on the payment instrument used to place the order.'
        },
        {
            header:'How will I get the refund against an order which placed with Cash on Delivery?',
            content:'Refund against orders delivered with Cash on delivery will credited in your JioMart wallet which can be utilized for future orders.'
        }
    ],
    "Delivery":[
        {
            header:'How will I know if JioMart delivers to my area?',
            content:'You can check the serviceability of your area while selecting your pin code when you place your order.'
        },
        {
            header:'How can I check for an expected date of delivery of an order I placed?',
            content:'You can check for an estimated date of delivery on the product description page by entering your pin code. Date of delivery may vary from product to product and is also dependent on the pin code of the delivery address. We try our best to delivery your orders as early as possible.'
        },
        {
            header:'Are there any delivery charges on the orders?',
            content:'Currently, we do not charge any delivery fee for the orders you place on JioMart.'
        }
    ],
    "LoyaltyProgram":[
        {
            header:'What is the AppnaMart?',
            content:'RelianceOne or ROne is the Loyalty Program of Reliance Retail. Members enjoy wide range of privileges & benefits and can earn RelianceOne points at all the following stores'
        },
        {
            header:'How do I become a RelianceOne Member?',
            content:'You can become a member by giving your phone number during billing at any of our store or by shopping on JioMart.com.'
        },
        {
            header:'What are benefits of AppnaMart?',
            content:'RelianceOne members get access to wide range of exclusive benefits and privileges across our partner stores.'
        },
        {
            header:'How do I know my current balance of ROne points?',
            content:'You can get the current balance of RelianceOne points by giving a missed call on 9212999888'
        },
        {
            header:'How to redeem ROne points?',
            content:'he redemption of ROne points is available both in physical stores and on JioMart.com while billing'
        }
    ],
};

export default HelpUsData;